import { render } from "./Inventory.vue?vue&type=template&id=5250fcdc&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=5250fcdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5250fcdc"]])

export default __exports__